"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = AuthorisationConsumer;

var _react = _interopRequireDefault(require("react")),
    _clientAuth = require("@devsta/client-auth"),
    _NotFound = _interopRequireDefault(require("../../NotFound")),
    _NoOrganisations = _interopRequireDefault(require("../../NoOrganisations")),
    _AuthorisationContext = require("../context/AuthorisationContext"),
    _isPublicUrl = _interopRequireDefault(require("../utils/isPublicUrl"));

function AuthorisationConsumer(a) {
  var b = a.children,
      c = a.requiresOrganisation,
      d = (0, _isPublicUrl["default"])() ? ["VIDEO_TOOL", "VIDEO_REVIEW"] : [];
  return _react["default"].createElement(_AuthorisationContext.AuthorisationContextConsumer, null, function (a) {
    var e = a.organisationMemberships,
        f = a.isShootsta,
        g = a.isShootstaEditor,
        h = a.isShootstaAdmin,
        i = a.selectedOrganisation,
        j = a.updateSelectedOrganisation,
        k = a.updateSelectedOrganisationData,
        l = _clientAuth.credentials.get(),
        m = l.user,
        n = l.auth,
        o = i || {
      permissions: d,
      includedAddonTypes: []
    };

    return c ? !m || !n || n && m.isAnonymous ? _react["default"].createElement(_NotFound["default"], null) : e && e.length ? b({
      organisationMemberships: e,
      isShootsta: f,
      isShootstaEditor: g,
      isShootstaAdmin: h,
      selectedOrganisation: o,
      updateSelectedOrganisation: j,
      updateSelectedOrganisationData: k
    }) : _react["default"].createElement(_NoOrganisations["default"], null) : b({
      organisationMemberships: e || [],
      isShootsta: f,
      isShootstaEditor: g,
      isShootstaAdmin: h,
      selectedOrganisation: o,
      updateSelectedOrganisation: j,
      updateSelectedOrganisationData: k
    });
  });
}